(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutribotanix-interactive-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.nb-finder').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const copy = JSON.parse(root.querySelector('[data-nb-copy]').textContent);
      const dialog = root.querySelector('[data-nb-dialog]');
      const backdrop = root.querySelector('[data-nb-backdrop]');
      const content = root.querySelector('[data-nb-content]');
      const back = root.querySelector('[data-nb-back]');
      const restart = root.querySelector('[data-nb-restart]');
      const progress = root.querySelector('[data-nb-progress]');
      const stepLabel = root.querySelector('[data-nb-step-label]');
      let history = [];
      let answers = {};
      let lastFocus;
      const campaign = 'botanical_routine_finder';
      const storageMs = Number(root.dataset.storageDays || 30) * 86400000;
      const trackedUrl = (url, outcome) => `${url}${url.includes('?') ? '&' : '?'}utm_source=interactive_finder&utm_medium=onsite&utm_campaign=${campaign}&utm_content=${outcome}`;
      const track = (event, detail) => {
        const payload = { event, finder_version:'1.0', ...detail };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        root.dispatchEvent(new CustomEvent(`nutribotanix:${event}`, { bubbles:true, detail:payload }));
      };
      const saveCompletion = (outcome) => {
        const payload = { answers, outcome, completed_at:new Date().toISOString(), expires_at:Date.now() + storageMs, version:'1.0' };
        localStorage.setItem('nb_finder_last_result', JSON.stringify(payload));
        track('finder_complete', payload);
      };
      const resolveRoutineOutcome = (format) => {
        const routine = answers.routine || 'daily';
        return `routine_${routine}_${format}`;
      };
      const fallbackOutcome = (key) => {
        const parts = key.replace('routine_','').split('_');
        const routine = parts[0];
        const format = parts[1] || answers.routine_format || answers.botanical_format || 'tea';
        const routineMeta = copy.routines[routine] || copy.routines.daily;
        const formatLinks = {
          powder:[[copy.labels.powders,'/collections/ayurvedic-essentials'],[copy.labels.routine_guide,'/pages/botanical-ingredient-library']],
          capsule:[[copy.labels.capsules,'/collections/supplements'],[copy.labels.routine_guide,'/pages/botanical-ingredient-library']],
          honey:[[copy.labels.botanical_honey,'/collections/botanical-honey-blends'],[copy.labels.routine_guide,'/pages/honey-learning-center']],
          tea:[[copy.labels.teas,'/collections/teas-tisanes-aromatic'],[copy.labels.routine_guide,'/pages/recipes-rituals']],
          open:[[copy.labels.routine_collection,routineMeta.url],[copy.labels.routine_guide,'/pages/everyday-botanical-routines']]
        }[format] || [[copy.labels.routine_collection,routineMeta.url]];
        return { title:routineMeta.title, body:routineMeta.body, primary:routineMeta.url, learn:'/pages/everyday-botanical-routines', items:formatLinks };
      };
      const renderQuestion = (key) => {
        const q = copy.questions[key];
        history.push(key);
        stepLabel.textContent = `${copy.step} ${history.length} ${copy.of} 3`;
        progress.style.width = `${Math.min(history.length,3) / 3 * 100}%`;
        content.innerHTML = `<h3 class="nb-finder__question"></h3><p class="nb-finder__help"></p><div class="nb-finder__options"></div>`;
        content.querySelector('h3').textContent = q.title;
        const help = content.querySelector('p');
        help.textContent = q.help || '';
        help.hidden = !q.help;
        const options = content.querySelector('.nb-finder__options');
        q.options.forEach((option) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nb-finder__option';
          button.textContent = option.label;
          button.addEventListener('click', () => {
            answers[key] = option.value;
            track('finder_answer', { question:key, answer:option.value, step:history.length });
            if (key === 'routine_format') return renderOutcome(resolveRoutineOutcome(option.value));
            if (option.outcome) return renderOutcome(option.outcome);
            renderQuestion(option.next);
          });
          options.appendChild(button);
        });
        back.hidden = history.length < 2;
        restart.hidden = true;
        options.querySelector('button')?.focus();
      };
      const renderOutcome = (key) => {
        const outcome = copy.outcomes[key] || fallbackOutcome(key);
        history.push('result');
        stepLabel.textContent = copy.labels.result;
        progress.style.width = '100%';
        const itemLinks = outcome.items.map(([label,url]) => `<a href="${trackedUrl(url,key)}" data-nb-result-link>${label}</a>`).join('');
        content.innerHTML = `<p class="nb-finder__result-kicker">${copy.labels.why}</p><h3 class="nb-finder__result-title"></h3><p class="nb-finder__why"></p><h4>${copy.labels.starting_points}</h4><div class="nb-finder__recommendations">${itemLinks}</div><div class="nb-finder__actions"><a class="nb-finder__primary" data-nb-primary>${copy.labels.shop}</a><a class="nb-finder__secondary" data-nb-learn>${copy.labels.learn}</a></div><p class="nb-finder__safety">${copy.labels.safety}</p>`;
        content.querySelector('.nb-finder__result-title').textContent = outcome.title;
        content.querySelector('.nb-finder__why').textContent = outcome.body;
        content.querySelector('[data-nb-primary]').href = trackedUrl(outcome.primary,key);
        content.querySelector('[data-nb-learn]').href = trackedUrl(outcome.learn,key);
        content.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => track('finder_cta_click', { outcome:key, destination:link.pathname })));
        back.hidden = true;
        restart.hidden = false;
        saveCompletion(key);
        content.querySelector('[data-nb-primary]')?.focus();
      };
      const open = () => {
        lastFocus = document.activeElement;
        dialog.hidden = false;
        backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
        history = [];
        answers = { entry_page:location.pathname };
        renderQuestion('start');
        track('finder_open', { entry_page:location.pathname });
      };
      const close = () => {
        dialog.hidden = true;
        backdrop.hidden = true;
        document.body.style.overflow = '';
        lastFocus?.focus();
      };
      root.querySelector('[data-nb-open]').addEventListener('click', open);
      root.querySelector('[data-nb-close]').addEventListener('click', close);
      backdrop.addEventListener('click', close);
      back.addEventListener('click', () => { history.pop(); const previous = history.pop() || 'start'; delete answers[previous]; renderQuestion(previous); });
      restart.addEventListener('click', () => { history = []; answers = { entry_page:location.pathname }; renderQuestion('start'); track('finder_restart', {}); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button,a[href]')].filter((el) => !el.hidden);
        if (!focusable.length) return;
        const first = focusable[0]; const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      const delay = Number(root.dataset.autoOpenSeconds || 0);
      const autoOpenedAt = Number(localStorage.getItem('nb_finder_auto_opened') || 0);
      const recentlyOpened = autoOpenedAt && (Date.now() - autoOpenedAt < storageMs);
      if (delay > 0 && !recentlyOpened && !Shopify.designMode) setTimeout(() => { localStorage.setItem('nb_finder_auto_opened',String(Date.now())); open(); }, delay * 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
